import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BusinessClientSimChangeBlockData from '../../../Models/Content/BusinessClientSimChangeBlockData';
import BusinessClientSimChangeMain from './BusinessClientSimChangeMain';

export default class BusinessClientSimChangeBlock extends EpiComponent<BusinessClientSimChangeBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessClientSimChangeMain iContent={this.props.data} context={this.getContext()} />;
  }
}
